import * as Yup from 'yup';

export const validationsPersonalData = Yup.object({
  firstName: Yup.string()
    .required('Campo requerido').max(50, 'La longitud maxima es 50').min(3, 'La longitud minima es 3'),
  lastName: Yup.string().required('Campo requerido').max(50, 'La longitud maxima es 50').min(3, 'La longitud minima es 3'),
  phone: Yup.string().required('Campo requerido').max(10, 'La longitud maxima es 10'),
});